import {postJson,post} from './http'
const baseUrl = '/api/capwhale/enrollevent'
const payUrl = '/api/capwhale/pay'
//获取首页列表数据
export const getIndexInfo = v => postJson(`${baseUrl}/index/getIndexInfo`, v.data, v.success, v.error)
//获取猜你喜欢
export const getGuessLikeList = v => postJson(`${baseUrl}/index/getGuessLikeList`, v.data, v.success, v.error)
//获取活动详情
export const getEventDetail = v => postJson(`${baseUrl}/event/getEventDetail`, v.data, v.success, v.error)
//获取评论列表
export const getCommentList = v => postJson(`${baseUrl}/event/getCommentList`, v.data, v.success, v.error)
//获取票种信息
export const getEventTicketInfo = v => postJson(`${baseUrl}/event/getEventTicketInfo`, v.data, v.success, v.error)
//获取推荐活动列表
export const getRecommendEvent = v => postJson(`${baseUrl}/event/getRecommendEvent`, v.data, v.success, v.error)
//收藏活动
export const operateEventFollowInfo = v => postJson(`${baseUrl}/event/operateEventFollowInfo`, v.data, v.success, v.error)
//提交评论信息
export const uploadCommentInfo = v => postJson(`${baseUrl}/event/uploadCommentInfo`, v.data, v.success, v.error)
//报名页面获取信息
export const getConfirmOrderinfo = v => postJson(`${baseUrl}/event/getConfirmOrderinfo`, v.data, v.success, v.error)
//提交报名信息
export const uploadEventEnrollInfo = v => postJson(`${baseUrl}/event/uploadEventEnrollInfo`, v.data, v.success, v.error)
//获取支付结果
export const queryOrderPayResultByEnroll = v => post(`${payUrl}/queryOrderPayResultByEnroll`, v.data, v.success, v.error)
//获取主办方活动列表
export const getEventByHost = v => postJson(`${baseUrl}/event/getEventByHost`, v.data, v.success, v.error)
//获取主办方详情
export const getHostDetail = v => postJson(`${baseUrl}/event/getHostDetail`, v.data, v.success, v.error)
//关注/取消关注主办方
export const operateHostFollowInfo = v => postJson(`${baseUrl}/event/operateHostFollowInfo`, v.data, v.success, v.error)
//搜索活动
export const getSearchList = v => postJson(`${baseUrl}/search/getSearchList`, v.data, v.success, v.error)